import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 11.1, AC-7: het HR-besluit op een urencorrectie, naar het model van
 * `useDecideLeaveCorrection`.
 *
 * Een eigen mutatie naast die van het eerste besluit, en om dezelfde reden als
 * het eindpunt eigen is (AD-29): dit besluit schrijft de HR-kolommen en pas
 * hierna landen de gewijzigde uren op de verlofrij. Dezelfde drie caches
 * raken verouderd en worden dus alle drie ververst.
 */
export function useDecideHrStapCorrectie() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      decision,
      reason,
    }: {
      id: number;
      decision: 'approve' | 'reject';
      reason?: string;
    }) => verlofApi.decideCorrectieHrStap(id, decision, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.all });
      queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
    },
  });
}
